import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';
import { HealthReadinessLayout } from '@/components/health-readiness/layout';
import { tabFromPathname } from '@/components/health-readiness/model';

/**
 * Health & Readiness (E20, tabs from T-0242 / E22 design §1): the header
 * and tab strip over the tab the URL names.
 *
 *   /engagements/$engagementId/health-readiness                 Overview
 *   …/domains[/$domainId] · …/criteria[/$criterionId]
 *   …/findings?domain=&severity=&status= · …/interviews · …/report · …/snapshots
 *
 * E20's `?item=` lands on the Overview route, which redirects it to its
 * tab; the old `/health/*`, `/golive/*`, `/readiness` and `/methodology`
 * routes redirect to the tabs (`components/health-readiness/legacy-redirect.ts`).
 */
export const Route = createFileRoute('/engagements/$engagementId/health-readiness')({
  component: HealthReadinessRoute,
});

function HealthReadinessRoute() {
  const { engagementId } = Route.useParams();
  const { pathname } = useLocation();
  return (
    <HealthReadinessLayout engagementId={engagementId} active={tabFromPathname(pathname)}>
      <Outlet />
    </HealthReadinessLayout>
  );
}
